import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { CommonService } from '../../services/common.service'

interface IAuthLayout {
    children: React.ReactNode
}

const AuthLayout = (props: IAuthLayout) => {
    const location = useLocation()

    const { children } = props
    return (
        <>
            <Helmet>
                <title>
                    SFP
                    {`${CommonService.textCapitalize(
                        location?.pathname?.replaceAll('/', ' - ')
                    )}`}
                </title>
            </Helmet>
            <div className="auth-wrapper">
                <div className="auth-layout text-center">
                    <img
                        className="auth-main-img"
                        src={require('../../assets/images/logo.png').default}
                        alt=""
                    />
                    <div>{children}</div>
                </div>
            </div>
        </>
    )
}

export default AuthLayout
